import { render } from "./send-smtp-email.vue?vue&type=template&id=4e966780&scoped=true"
import script from "./send-smtp-email.vue?vue&type=script&lang=js"
export * from "./send-smtp-email.vue?vue&type=script&lang=js"

import "./send-smtp-email.vue?vue&type=style&index=0&id=4e966780&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e966780"]])

export default __exports__